import { useEffect } from 'react'
import { getPlatformAPI } from '../lib/platform'

/**
 * Meldet dem Hauptprozess, dass das Hauptfenster die App zeigt — nicht Setup oder Anmeldung (#158,
 * Entscheidung 14). Ein per Doppelklick geöffnetes Backup wartet darauf und geht erst dann auf.
 */
export function useMainWindowReady() {
  useEffect(() => {
    if (getPlatformAPI().platform !== 'electron' || !window.api?.invoke) return
    void Promise.resolve(window.api.invoke('backup:main-ready')).catch(() => {})
  }, [])
}
